var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"h-screen antialiased"}),_c('notifications',{staticClass:"mt-16",attrs:{"position":"top right","speed":500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }